import React from "react";

const LoadingSpinner = ({
  message = "Loading archives...",
  messageColor = "",
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-[142px] text-text-muted font-oxanium">
      <div className="relative h-16 w-16">
        <div className="absolute inset-0 rounded-full border-2 border-accent-border/30" />
        <div className="absolute inset-0 rounded-full lab-spinner-sweep" />
        <div className="absolute inset-0 rounded-full lab-spinner-glow" />
      </div>
      <p
        className={`mt-5 text-sm tracking-wide ${
          messageColor || "text-text-muted"
        }`}
      >
        {message}
      </p>
      <style>
        {`
          .lab-spinner-sweep {
            background: conic-gradient(from 0deg, rgba(0, 150, 199, 0) 0deg, rgba(0, 150, 199, 0.85) 270deg, #90E0EF 360deg);
            -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
                    mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
            animation: lab-spinner-rotate 1.2s linear infinite;
          }

          .lab-spinner-glow {
            box-shadow: inset 0 0 16px 2px rgba(0, 180, 216, 0.18);
            animation: lab-spinner-pulse 2.4s ease-in-out infinite;
          }

          @keyframes lab-spinner-rotate {
            to { transform: rotate(360deg); }
          }

          @keyframes lab-spinner-pulse {
            0%, 100% { opacity: 0.4; }
            50% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;
